import { render, staticRenderFns } from "./trigger-collection-load.vue?vue&type=template&id=b00ff860&"
import script from "./trigger-collection-load.vue?vue&type=script&lang=js&"
export * from "./trigger-collection-load.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports